import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=5c5b3879&scoped=true"
import script from "./ShowMessage.vue?vue&type=script&lang=js"
export * from "./ShowMessage.vue?vue&type=script&lang=js"
import style0 from "./ShowMessage.vue?vue&type=style&index=0&id=5c5b3879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b3879",
  null
  
)

export default component.exports